export let allFolders = "sl9Ilb";
export let currentMailbox = "HxE3Nb";
export default {allFolders,currentMailbox};